import * as Yup from 'yup'

export const cleaningStatusSchema = Yup.object().shape({
  CampamentoId: Yup.string().required('Campamento es requerido'),
  ServiceSchedulingId: Yup.string().required('Programación de servicio es requerido'),
  FechaIni: Yup.string().required('Fecha de inicio es requerido'),
  FechaFin: Yup.string().required('Fecha de fin es requerido'),
})

export const addObservationSchema = Yup.object().shape({
  MotivoId: Yup.string().required('Motivo es requerido' ),
  EscaneoActividadId: Yup.string().required('Escaneo actividad es requerido'),
  Comentarios: Yup.string().required('Comentarios es requerido'),
})